import { useTranslate } from 'hooks/useTranslate';
import { useDispatch } from 'react-redux';

import { Partner } from 'types';

import SendCommunicationModal from 'modules/_shared/components/Modals/SendCommunicationModal';
import { setModal } from 'modules/_shared/redux/modalActions';
import { useGetPartnersSectionPermissions } from 'modules/partners/hooks/useGetPartnerSectionsPermissions';

type Props = {
  partner: Partner;
};

const PartnerDetailSendEmailButton = ({ partner }: Props) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const { isReadOnly } = useGetPartnersSectionPermissions().data;

  const handleOpenModal = () => {
    dispatch(setModal(<SendCommunicationModal defaultRecipient={partner} />));
  };

  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={handleOpenModal}
      disabled={isReadOnly}
    >
      <em className="icon ni ni-send" />
      <span>{t('SendEmail')}</span>
    </button>
  );
};

export default PartnerDetailSendEmailButton;
